import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import IndiaGrowth from './components/IndiaGrowth';
import Stats from './components/Stats';
import InvestorRelations from './components/InvestorRelations';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CompanyOverviewPage from './pages/CompanyOverviewPage';
import DirectorsPage from './pages/DirectorsPage';
import ManufacturingPage from './pages/ManufacturingPage';
import QualityPage from './pages/QualityPage';
import MarketDetailPage from './pages/MarketDetailPage';
import RecyclablePage from './pages/RecyclablePage';
import FactoryGalleryPage from './pages/FactoryGalleryPage';
import InvestorRelationsPage from './pages/InvestorRelationsPage';
import './App.css';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={
            <>
              <Header />
              <Hero />
              <IndiaGrowth />
              <Stats />
              <InvestorRelations />
              <Contact />
              <Footer />
            </>
          } />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:productId" element={<ProductDetailPage />} />
          <Route path="/about/company-overview" element={<CompanyOverviewPage />} />
          <Route path="/about/directors" element={<DirectorsPage />} />
          <Route path="/about/manufacturing" element={<ManufacturingPage />} />
          <Route path="/about/quality" element={<QualityPage />} />
          <Route path="/about/factory-gallery" element={<FactoryGalleryPage />} />
          <Route path="/markets/:marketId" element={<MarketDetailPage />} />
          <Route path="/i-am-recyclable" element={<RecyclablePage />} />
          <Route path="/investor-relations" element={<InvestorRelationsPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
